<template>
	<div class="Goodslistitem" @click="itemclick">
		<img v-lazy="showimage">
		<div class="goods-info">
			<p>{{goodsitem.title}}</p>
			<!-- <span class="price">{{goodsitem.price}}</span> -->
			<!-- <span class="collect">{{goodsitem.cfav}}</span> -->
		</div>
	</div>
</template>

<script scoped>
	export default {
		name:"Goodslistitem",
		props:{
			goodsitem:{
				type:Object,
				default(){
					return {}
				}
			}
		},
		computed:{
			showimage(){
				return this.goodsitem.img || '~assets/images/loading.png'
			}
		},
		methods:{
			itemclick(){
				this.$router.push(
          { path:'/detail/'+this.goodsitem.url,query:{title: this.goodsitem.title}}
        )
			}
		}
	}
</script>

<style scoped>
	.Goodslistitem {
	  padding-bottom: 50px;
    margin-bottom: 5px;
	  position: relative;
    overflow: hidden;
	  width: 23%;
    transition:all 0.1s;
	}
  .Goodslistitem:hover {
    transform: scale(0.9);
    border-radius: 5px;
  }
	.Goodslistitem img {
	  width: 100%;
	  height:100%;
	  border-radius: 5px;
    transition:all 0.8s;
	}
  .Goodslistitem img:hover {
    border-radius: 5px;
  }

	.goods-info {
	  font-size: 12px;
	  position: absolute;
	  bottom: 5px;
	  left: 0;
	  right: 0;
	  overflow: hidden;
	  text-align: center;
	}

	.goods-info p {
	  overflow: hidden;
    text-overflow: ellipsis;
	  white-space: nowrap;
	  margin-bottom: 3px;
    font-size: 17px;
	}

	.goods-info .price {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
		color: red;
	  margin-right: 20px;
	}

	.goods-info .collect {
	  position: relative;

	}

	.goods-info .collect::before {
	  content: '';
	  position: absolute;
	  left: -15px;
	  top: -1px;
	  width: 14px;
	  height: 14px;
	  /* background: url("~assets/img/common/collect.svg") 0 0/14px 14px; */
	}
</style>
